'use client'

import React, { useEffect, useState } from "react";
import { CurrentSnackbarProps, SnackbarDataTypes } from "@/types/types";
import { SnackbarEventTypes } from "@/enum/snackbarEventTypes.ts";
import { Snackbar, useMediaQuery } from "@mui/material";
import Alert from '@mui/material/Alert';
import Image from "next/image";
import useUniqueTabId from "@/common/hooks/useUniqueTabId.ts";
import EllipsisLink from "@/common/components/Text/EllipsisLink.tsx";
import { routes } from "@/routes.ts";
import EllipsisTextLine from "@/common/components/Text/EllipsisTextLine.tsx";
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";
import useSessionUser from "@/common/hooks/useSessionUser.ts";
import { Theme } from "@mui/material/styles";

export default function UserEventSharedSegmentSnackbar(props: CurrentSnackbarProps): React.ReactNode {
  const { snackbar } = props
  const user = useSessionUser();
  const [uniqueTabId] = useUniqueTabId()
  const [isOpen, setIsOpen] = useState(false)
  const snackbarData = snackbar.data as SnackbarDataTypes[SnackbarEventTypes.USER_EVENT_SHARED_SEGMENT]
  const isMediumScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  useEffect(() => {
    console.log(snackbar)
    const isOpen = uniqueTabId !== snackbar.uniqueTabId || user?.id !== snackbar.eventCreatedByUser.id
    setIsOpen(isOpen)
  }, [
    snackbar,
    snackbarData.track.id,
    snackbarData.track.id,
    user?.id,
    snackbar.eventCreatedByUser.id,
    snackbar.uniqueTabId,
    uniqueTabId
  ])

  return <>
    {
      <Snackbar
        open={isOpen}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{ marginBottom: isMediumScreen ? 12 : 10 }}
        onClose={() => setIsOpen(false)}
      >
        <Alert
          icon={
            (
              snackbar.eventCreatedByUser.avatar && <Image
                height={40}
                width={40}
                src={snackbar.eventCreatedByUser.avatar || ""}
                alt={snackbar.eventCreatedByUser.email ?? ''}
              />
            )
          }
          severity="info"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.eventCreatedByUser.email} has shared a track selection with you:
          <br />
          <em>{snackbarData.segment.labelText}</em>
          <br />
          <strong>
            <EllipsisLink
              maxWidth={250}
              routeName={routes.DASHBOARD}
              routeParams={{
                searchParams: { [URLSearchParamKeys.TRACK]: snackbarData.track.explorerItemId }
              }}
              textContent={snackbarData.track.name}
            />

            {snackbarData.message &&
              <>
                <br />
                <small>
                  &nbsp;<EllipsisTextLine maxWidth={200} textContent={snackbarData.message} />
                </small>
              </>
            }
          </strong>
        </Alert>
      </Snackbar>
    }
  </>
}
